interface BuildAuthPathOptions {
  signup?: boolean;
  basePath?: string;
}

export const getCurrentPathWithSearch = (): string =>
  `${window.location.pathname}${window.location.search}${window.location.hash}`;

export const buildAuthPath = (
  redirectPath: string,
  options?: BuildAuthPathOptions
): string => {
  const params = new URLSearchParams();

  if (options?.signup) {
    params.set('signup', 'true');
  }

  if (redirectPath) {
    params.set('redirect', redirectPath);
  }

  const query = params.toString();
  const basePath = options?.basePath ?? '/auth';

  return query ? `${basePath}?${query}` : basePath;
};
